import { render, staticRenderFns } from "./FirstLastButtonPagination.vue?vue&type=template&id=01fe8ff2"
import script from "./FirstLastButtonPagination.vue?vue&type=script&lang=js"
export * from "./FirstLastButtonPagination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports